import React, { Component } from 'react';
import Relay from 'react-relay';
import { css } from 'glamor';
import { FormattedMessage } from 'react-intl';

import { FAMILY_EXTENDED_BOLD } from 'depop/styles/typography';

import { ProductList } from 'depop/components/ProductList';

class SimilarProducts extends Component {
  props: {
    productRelations: Object,
    locationState: ?String,
  };

  render() {
    const { productRelations } = this.props;

    return (
      <div>
        {
          productRelations
          && productRelations.similar
          && productRelations.similar.edges
          && productRelations.similar.edges.length > 0
          ? <div {...css({ marginTop: '20px' })}>
              <h1
                {...css({
                  fontSize: '16px',
                  margin: '10px 0',
                  fontFamily: FAMILY_EXTENDED_BOLD,
                })}>
                <FormattedMessage
                  id="ProductDetail.similarItems"
                  description="Title for similar items section"
                  defaultMessage="More things you might like"
                />
              </h1>
              <ProductList
                from="similar items"
                listName="Similar items"
                products={productRelations.similar.edges.map(edge => edge.node)}
              />
            </div>
          : null}
      </div>
    );
  }
}

export default Relay.createContainer(SimilarProducts, {
  fragments: {
    productRelations: () => Relay.QL`
      fragment on ProductRelations {
        similar(first: 12) {
          edges {
            node {
              ${ProductList.getFragment('products')}
            }
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/components/SimilarProducts.js